<template>
  <div class="p-d-flex p-jc-center main" id="login-page">
    <Toast />

    <div class="p-d-flex p-flex-column login-form">
      <img id="profile-img" src="../assets/Intranet_logo.png" />
      <span class="p-mt-4 p-d-flex p-jc-center login-border">
        <h4>Intranet Login</h4>
      </span>
      <form name="form" @submit.prevent="handleLogin" class="p-mt-1">
        <div class="p-d-flex p-flex-column">
          <label class="force-top-0" for="username">Username</label>
          <InputText
            id="username"
            name="username"
            placeholder="Username"
            v-model="user.username"
            v-validate="'required'"
            type="text"
            v-bind:class="[
              { 'p-error': errors.has('username') },
              'form-control',
            ]"
            v-on:keyup.enter="handleLogin()"
          />
          <small v-if="errors.has('username')" class="p-error" role="alert">
            Username é obrigatório
          </small>
        </div>

        <div class="p-d-flex p-flex-column">
          <label class="force-top-0" for="inputtext">Password</label>
          <Password
            toggleMask
            :feedback="false"
            id="password"
            placeholder="Password"
            v-model="user.password"
            v-validate="'required'"
            autocomplete="'current-password'"
            v-bind:class="[
              { 'p-error': errors.has('password') },
              'form-control',
            ]"
            name="password"
            v-on:keyup.enter="handleLogin()"
          />
          <small v-if="errors.has('password')" class="p-error" role="alert">
            Password é obrigatório
          </small>
        </div>

        <div class="p-d-flex p-jc-center p-mt-3">
          <Button label="Login >" @click="handleLogin()" class="login-button" />
        </div>
      </form>
    </div>

    <Dialog
      header="Autorização de Telemóvel"
      :visible.sync="showPhoneAuthDialog"
      :modal="true"
      :closable="false"
      :style="{ width: '400px' }"
    >
      <p>Autoriza que a empresa utilize o seu telemóvel pessoal para comunicações Internas?</p>
      <template #footer>
        <Button label="Sim, autorizo" icon="pi pi-check" class="p-button-success" @click="phoneAuthResponse(1)" />
        <Button label="Não autorizo" icon="pi pi-times" class="p-button-danger" @click="phoneAuthResponse(2)" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import User from "../models/user";
import AuthService from "../services/auth.service";

export default {
  name: "Login",
  data() {
    return {
      user: new User("", ""),
      loading: false,
      message: "",
      showPhoneAuthDialog: false,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push("/").catch(() => {});
    }
  },
  methods: {
    async handleLogin() {
      this.$toast.removeAllGroups();
      this.loading = true;
      this.$validator.validateAll().then(async (isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }

        if (this.user.username && this.user.password) {
          let user = { ...this.user };
          user.password = await this.encryptPassword(this.user.password)
          this.$store.dispatch("auth/login", user).then(
            (userData) => {
              if (userData && userData.showPhoneAuthorizationModal) {
                this.showPhoneAuthDialog = true;
              } else {
                this.$router.push("/").catch(() => {});
              }
            },
            (error) => {
              this.loading = false;
              this.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();

              this.$toast.add({
                severity: "error",
                summary: "Erro no Login",
                detail: this.message,
              });
            }
          );
        }
      });
    },
    async phoneAuthResponse(authorization) {
      this.showPhoneAuthDialog = false;
      const response = await AuthService.updatePhoneAuthorization(authorization);
      if (!response) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Não foi possível registar a sua resposta. Tente novamente.",
        });
        this.showPhoneAuthDialog = true;
        return;
      }
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        user.phoneAuthorization = authorization;
        localStorage.setItem("user", JSON.stringify(user));
      }
      this.$router.push("/").catch(() => {});
    },
    async encryptPassword(password) {
      const encoder = new TextEncoder();
      const data = encoder.encode(password);
      const hash = await crypto.subtle.digest('SHA-256', data);
      return Array.from(new Uint8Array(hash)).map(b => b.toString(16).padStart(2, '0')).join('');
    }
  },
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 50px !important;
  padding: 40px 40px;
}

.login-border {
  border-bottom: 1px dashed #ccc;
}

.login-button {
  background-color: #f24f00 !important;
  border-color: #f24f00 !important;
  width: 125px;
  border-radius: 12px;
  font-weight: bold;
}

.login-button:hover {
  background-color: #f24f00 !important;
  border-color: #f24f00 !important;
}

.main {
  min-height: 60vh;
  background-image: url(../assets/BKG_Intranet_01.jpg);
  background-position: center;
  background-size:cover;
  background-repeat: no-repeat;
}

#login-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.login-form {
  margin-top: 25vh;
}


</style>
